import { useKeycloak } from "@react-keycloak/web";
import { Avatar, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";

export default function ProfileMenu() {
  const auth = useAppSelector((state) => state.auth);
  const { keycloak } = useKeycloak();

  let url: string;

  if (auth.role === "super_admin" || auth.role === "Admin") {
    url = "/admin";
  } else {
    url = "/user";
  }

  const handleLogout = () => {
    keycloak.logout({
      redirectUri: window.location.origin + "/",
    });
  };

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="!left-auto !right-5"
      dropdownRender={() => (
        <ul className="list-none bg-white shadow p-1 rounded">
          <li>
            <Link
              to={`${url}/profile`}
              className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded block"
            >
              My Profile
            </Link>
          </li>
          <li
            onClick={handleLogout}
            className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
          >
            Logout
          </li>
        </ul>
      )}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <Avatar size={44} src={PLACEHOLDER_IMG} />
        {/* <span className="text-[#555b6d] text-base font-medium flex items-center">
          {login?.firstName} <BottomDropdownIcon />
        </span> */}
      </div>
    </Dropdown>
  );
}
